var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ExternalModule',{attrs:{"external-module-name":"mpov","url":_vm.url}})}
var staticRenderFns = []

export { render, staticRenderFns }